export type { ProductGridProps } from './ProductGrid';
export { default } from './ProductGrid';
